import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ChargeCriteriaContMain from "presentation/view/container/Criteria/ChargeCriteriaContMain";

CommonEntrypoint(<ChargeCriteriaContMain/>)